/* eslint-disable camelcase */
import { getRoles } from 'api/roles.api';
import { getUserByUid } from 'api/users.api';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetCompanySettingsData = async () => {
  $form.reset({});
  $view.update({
    isLoading: true,
    error: null,
  });

  try {
    const [userData, { data: roles }] = await Promise.all([
      getUserByUid($user.value.uid),
      getRoles({ userType: $user.value.userType }),
    ]);

    if (userData) {
      const { organization } = userData;
      const address = organization?.addresses?.[0];
      const isAngel = organization?.investorType === 'Angel';

      const teams = organization.teams.map((team) => (
        { ...team, users: team.usersOnTeams.map((item) => (item.user)) }
      ))?.sort((a, b) => a.id - b.id);

      $view.update({
        roleOptions: roles.map((role) => ({
          label: role.name,
          value: role.id,
        })),
        teamOptions: teams.map((team) => ({
          label: team.name,
          value: team.id,
        })),
        isAngel,
        organizationName: organization?.name || '',
        logo: organization?.logoImage || '',
        logoColors: organization?.logoColors || [],
      });

      $form.update({
        organizationName: organization?.name || '',
        email: organization?.email || '',
        phone: organization?.phone || '',
        website: organization?.website || '',
        country: address?.countryCode || '',
        state: address?.provinceCode || '',
        street: address?.street || '',
        city: address?.city || '',
        zip: address?.postalCode || '',
        logoImage: organization?.logoImage || '',
      });
    }
  } catch (error) {
    displayError({
      message: 'Failed to load company settings. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isLoading: false });
  }
};
